// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.styles_button__mQsu4 {
  padding: unset;
  display: flex;
  border: 1px dashed grey;
  justify-content: center;
  align-items: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/auth/submodules/invitations/components/CreateInvitationButton/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB,EAAA","sourcesContent":["button.button {\n    padding: unset;\n    display: flex;\n    border: 1px dashed grey;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `styles_button__mQsu4`
};
export default ___CSS_LOADER_EXPORT___;
